
class QuickView extends HTMLElement {
  variantPicker; loaded; loader; price; compare; input; button; templateAvailable; templateUnavailable;

  static selectors = {
    loader: '[data-loader]',
    price: '[data-price]',
    compare: '[data-compare]',
    input: '[name="id"]',
    button: '[data-button]',
    templateAvailable: '[data-template-available]',
    templateUnavailable: '[data-template-unavailable]',
  };
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.variantPicker = this.querySelector('variant-picker');
    this.loader = this.querySelector(QuickView.selectors.loader);
    this.price = this.querySelector(QuickView.selectors.price);
    this.compare = this.querySelector(QuickView.selectors.compare);
    this.input = this.querySelector(QuickView.selectors.input);
    this.button = this.querySelector(QuickView.selectors.button);
    this.templateAvailable = this.querySelector(QuickView.selectors.templateAvailable).innerHTML;
    this.templateUnavailable = this.querySelector(QuickView.selectors.templateUnavailable).innerHTML;

    if(this.variantPicker){
      this.addEventListener('shown.bs.offcanvas', () => {
        if(!this.loaded){
          this.variantPicker.load();
        }
      });
      this.variantPicker.addEventListener(Utils.VARIANT_LOADED, (e) => {
        this.loaded = true;
        this.closeLoader();
      });
      this.variantPicker.addEventListener(Utils.VARIANT_CHANGED, (e) => {
        this.refreshVariant(e.detail);
      });
      this.variantPicker.addEventListener(Utils.VARIANT_SELECTED_CLICKED, (e) => {
        this.add();
      });
    } else {
      this.closeLoader(); 
    }

    if(this.button != undefined){
      this.button.addEventListener('click', () => {
        this.add();
      });
    }
  }

  refreshVariant = (detail) => {
    const variant = detail.variant;
    if(this.price != undefined)
      this.price.innerText = Utils.money(variant.price);
    
    if(this.compare != undefined){
      if(variant.price == variant.compare_at_price || variant.compare_at_price == null)
        this.compare.innerText = '';
      else
        this.compare.innerText = Utils.money(variant.compare_at_price);
    }
    
    if(this.input != undefined)
      this.input.value = variant.id;

    if(this.button != undefined) {
      const newButton = document.createElement('div');
      if(variant.available){
        newButton.innerHTML = this.templateAvailable;
      }
      else{
        newButton.innerHTML = this.templateUnavailable;
      }
      this.button.parentNode.replaceChild(newButton.querySelector('button'), this.button);
      this.button = this.querySelector(QuickView.selectors.button);
      this.button.addEventListener('click', () => {
        this.add();
      });
    }

    if(this.variantPicker != undefined)
      this.variantPicker.updateAvailabilities();

    if(detail.input != undefined && detail.input.dataset.lastVariant != undefined)
      this.add();
  }

  add = () => {
    Utils.addTocart({
      form: this.querySelector('form'),
      beforeAdd: (id) => {
        this.openLoader();
      },
      afterAdd: (added) => {
        const offcanvas = bootstrap.Offcanvas.getInstance(this);
        offcanvas.hide();
      },
      finally: () => {
        this.closeLoader();
      }
    });
  }

  openLoader = () => {
    if(this.loader)
      this.loader.classList.remove('d-none');
  }

  closeLoader = () => {
    if(this.loader)
      this.loader.classList.add('d-none');
  }
}
if (!window.customElements.get("quick-view")) {
  window.customElements.define("quick-view", QuickView);
}